module.exports = __webpack_public_path__ + "static/GalaxieCopernicus-Semibold-17c62d2b44cc1b0c95aece0fdf6dcf3d.woff2";